import styled from 'styled-components';
import { TableCellMixin } from '../../mixins/components/TableCellMixin';
export var StyledTableCell = /*#__PURE__*/styled.td.withConfig({
  displayName: "StyledTableCell",
  componentId: "c11n-8-111-1__sc-1ijd1ns-0"
})(["", ""], TableCellMixin);